import * as Types from '../../../../gql/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type BulkEditBillingAdminMutationVariables = Types.Exact<{
  userPrincipalName: Types.Scalars['String'];
  projectNumbers: Array<Types.Scalars['Int']> | Types.Scalars['Int'];
}>;


export type BulkEditBillingAdminMutation = { __typename?: 'MutationModel', projects?: { __typename?: 'ProjectsMutationModel', editBillingAdmin?: { __typename?: 'ValidationResponse', errors?: Array<{ __typename?: 'ValidationError', argumentName?: string | null, message: string } | null> | null } | null } | null };


export const BulkEditBillingAdminDocument = gql`
    mutation BulkEditBillingAdmin($userPrincipalName: String!, $projectNumbers: [Int!]!) {
  projects {
    editBillingAdmin(
      userPrincipalName: $userPrincipalName
      projectNumbers: $projectNumbers
    ) {
      errors {
        argumentName
        message
      }
    }
  }
}
    `;
export type BulkEditBillingAdminMutationFn = Apollo.MutationFunction<BulkEditBillingAdminMutation, BulkEditBillingAdminMutationVariables>;

/**
 * __useBulkEditBillingAdminMutation__
 *
 * To run a mutation, you first call `useBulkEditBillingAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkEditBillingAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkEditBillingAdminMutation, { data, loading, error }] = useBulkEditBillingAdminMutation({
 *   variables: {
 *      userPrincipalName: // value for 'userPrincipalName'
 *      projectNumbers: // value for 'projectNumbers'
 *   },
 * });
 */
export function useBulkEditBillingAdminMutation(baseOptions?: Apollo.MutationHookOptions<BulkEditBillingAdminMutation, BulkEditBillingAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkEditBillingAdminMutation, BulkEditBillingAdminMutationVariables>(BulkEditBillingAdminDocument, options);
      }
export type BulkEditBillingAdminMutationHookResult = ReturnType<typeof useBulkEditBillingAdminMutation>;
export type BulkEditBillingAdminMutationResult = Apollo.MutationResult<BulkEditBillingAdminMutation>;
export type BulkEditBillingAdminMutationOptions = Apollo.BaseMutationOptions<BulkEditBillingAdminMutation, BulkEditBillingAdminMutationVariables>;